module.exports = __webpack_public_path__ + "static/media/telephone.2009ed73.svg";